import http from "@/http";

const baseUrl = "api/gestao-projetos";

export const buscarPainel = (filtros = {}) => {
  return http.get(`${baseUrl}/painel`, { params: filtros });
};

export const buscarProjetos = (filtros = {}) => {
  return http.get(`${baseUrl}/projetos`, { params: filtros });
};

export const buscarProjeto = (idProjeto) => {
  return http.get(`${baseUrl}/projetos/${idProjeto}`);
};

export const buscarUnidadesRegionaisPublicas = () => {
  return http.get("api/UnidadeRegional/publico");
};

export const buscarMunicipiosPublicos = () => {
  return http.get("api/municipio/publico");
};

export const buscarProjetosDetalhesLote = (ids = []) => {
  const params = new URLSearchParams();
  ids
    .filter((id) => Number.isFinite(Number(id)))
    .forEach((id) => params.append("ids", String(id)));
  return http.get(`${baseUrl}/projetos/detalhes-lote?${params.toString()}`);
};

export const prepararMensuracaoProjeto = (idProjeto) => {
  return http.get(`${baseUrl}/projetos/${idProjeto}/mensuracoes/preparar`);
};

export const listarMensuracoesProjeto = (idProjeto) => {
  return http.get(`${baseUrl}/projetos/${idProjeto}/mensuracoes`);
};

export const obterMensuracaoProjeto = (idProjeto, idMensuracao) => {
  return http.get(
    `${baseUrl}/projetos/${idProjeto}/mensuracoes/${idMensuracao}`
  );
};

export const registrarMensuracaoProjeto = (idProjeto, payload) => {
  return http.post(`${baseUrl}/projetos/${idProjeto}/mensuracoes`, payload);
};

export const buscarPdms = (filtros = {}) => {
  return http.get(`${baseUrl}/pdm`, { params: filtros });
};

export const buscarPdmDetalhe = (idPdm) => {
  return http.get(`${baseUrl}/pdm/${idPdm}`);
};

export const criarPdmMunicipal = (payload) => {
  return http.post(`${baseUrl}/pdm`, payload);
};

export const atualizarPdmMunicipal = (idPdm, payload) => {
  return http.put(`${baseUrl}/pdm/${idPdm}`, payload);
};

export const excluirPdmMunicipal = (idPdm) => {
  return http.delete(`${baseUrl}/pdm/${idPdm}`);
};

export const criarEixoPdm = (idPdm, payload) => {
  return http.post(`${baseUrl}/pdm/${idPdm}/eixos`, payload);
};

export const atualizarEixoPdm = (idPdm, idEixo, payload) => {
  return http.put(`${baseUrl}/pdm/${idPdm}/eixos/${idEixo}`, payload);
};

export const excluirEixoPdm = (idPdm, idEixo) => {
  return http.delete(`${baseUrl}/pdm/${idPdm}/eixos/${idEixo}`);
};

export const buscarEixosPdms = () => {
  return http.get(`${baseUrl}/pdm/eixos`);
};

export const vincularProjetoAoEixo = (idPdm, idEixo, payload) => {
  return http.post(`${baseUrl}/pdm/${idPdm}/eixos/${idEixo}/projetos`, payload);
};

export const criarObjetivoOkr = (idPdm, idEixo, payload) => {
  return http.post(`${baseUrl}/pdm/${idPdm}/eixos/${idEixo}/okr/objetivos`, payload);
};

export const atualizarObjetivoOkr = (idPdm, idEixo, idObjetivo, payload) => {
  return http.put(
    `${baseUrl}/pdm/${idPdm}/eixos/${idEixo}/okr/objetivos/${idObjetivo}`,
    payload
  );
};

export const excluirObjetivoOkr = (idPdm, idEixo, idObjetivo) => {
  return http.delete(
    `${baseUrl}/pdm/${idPdm}/eixos/${idEixo}/okr/objetivos/${idObjetivo}`
  );
};

export const criarResultadoOkr = (idPdm, idEixo, idObjetivo, payload) => {
  return http.post(`${baseUrl}/pdm/${idPdm}/eixos/${idEixo}/okr/objetivos/${idObjetivo}/resultados`, payload);
};

export const atualizarResultadoOkr = (
  idPdm,
  idEixo,
  idObjetivo,
  idResultado,
  payload
) => {
  return http.put(
    `${baseUrl}/pdm/${idPdm}/eixos/${idEixo}/okr/objetivos/${idObjetivo}/resultados/${idResultado}`,
    payload
  );
};

export const excluirResultadoOkr = (idPdm, idEixo, idObjetivo, idResultado) => {
  return http.delete(
    `${baseUrl}/pdm/${idPdm}/eixos/${idEixo}/okr/objetivos/${idObjetivo}/resultados/${idResultado}`
  );
};

export const obterMensuracaoOkr = (idPdm, idsEixo = []) => {
  const params = new URLSearchParams();
  idsEixo
    .filter((id) => Number.isFinite(Number(id)))
    .forEach((id) => params.append("idsEixo", String(id)));
  const sufixo = params.toString() ? `?${params.toString()}` : "";
  return http.get(`${baseUrl}/pdm/${idPdm}/okr/mensuracao${sufixo}`);
};

export const registrarMensuracaoOkr = (idPdm, payload) => {
  return http.post(`${baseUrl}/pdm/${idPdm}/okr/mensuracao`, payload);
};

export const criarProjeto = (payload) => {
  return http.post(`${baseUrl}/projetos`, payload);
};

export const atualizarProjeto = (idProjeto, payload) => {
  return http.put(`${baseUrl}/projetos/${idProjeto}`, payload);
};

export const definirVinculoMetricaAcao = (
  idProjeto,
  idAcao,
  idMetrica,
  vinculado
) => {
  return http.put(
    `${baseUrl}/projetos/${idProjeto}/acoes/${idAcao}/metricas/${idMetrica}`,
    { vinculado }
  );
};

export const excluirProjeto = (idProjeto) => {
  return http.delete(`${baseUrl}/projetos/${idProjeto}`);
};

export const buscarOpcoes = () => {
  return http.get(`${baseUrl}/opcoes`);
};

export const buscarUsuariosProjeto = (filtros = {}) => {
  return http.get(`${baseUrl}/usuarios`, { params: filtros });
};

export const criarUsuarioProjeto = (payload) => {
  return http.post(`${baseUrl}/usuarios`, payload);
};

export const buscarInstituicoesProjeto = (filtros = {}) => {
  return http.get(`${baseUrl}/instituicoes`, { params: filtros });
};

export const criarInstituicaoProjeto = (payload) => {
  return http.post(`${baseUrl}/instituicoes`, payload);
};

export const gerarRelatorioPanorama = (filtros = {}) => {
  return http.get(`${baseUrl}/relatorios/panorama`, { params: filtros });
};

export const gerarRelatorioProgresso = (filtros = {}) => {
  return http.get(`${baseUrl}/relatorios/progresso`, { params: filtros });
};
